import { getApps, initializeApp } from "firebase/app";
import { getPerformance } from "firebase/performance";
import { getRemoteConfig } from "firebase/remote-config";

const config = {
  apiKey: `${process.env.REACT_APP_FIREBASE_API_KEY}`,
  authDomain: `${process.env.REACT_APP_FIREBASE_AUTH_DOMAIN}`,
  projectId: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}`,
  appId: `${process.env.REACT_APP_FIREBASE_APP_ID}`,
};

let app;
const initializedApps = getApps();

if (!initializedApps.length) {
  app = initializeApp(config);
} else {
  app = initializedApps[0];
}

const perf = getPerformance(app);
const remoteConfig = getRemoteConfig(app);

// set to 1 hour
remoteConfig.settings.minimumFetchIntervalMillis = 60 * 60 * 1000;

export { perf, remoteConfig };
